// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3767":"86388bff","6072":"86388bff","7270":"43771b4a","7525":"f3457214"}[chunkId] + ".chunk.css";
};